import { ReactComponent as NoWifiIcon } from "assets/svgs/network/no_wifi.svg";
import NetworkIcon from "components/layout/status/NetworkIcon";

import type { RobotWifiState } from "lib/hooks/useRobotWifiStatus";

const noWifiIconClass =
    "inline-block h-4 w-4 shrink-0 align-middle text-white/60";

type Props = {
    wifi: RobotWifiState;
    className?: string;
};

const WifiStatusBarIcon: React.FC<Props> = ({ wifi, className = "" }) => {
    if (wifi.kind === "loading") {
        return (
            <div className={`inline-flex shrink-0 items-center ${className}`} title="Wi-Fi…">
                <NetworkIcon status={0} className="shrink-0" />
            </div>
        );
    }

    if (wifi.kind === "unavailable") {
        return (
            <div className={`inline-flex shrink-0 items-center ${className}`} title="Wi-Fi status unavailable">
                <NoWifiIcon className={noWifiIconClass} />
            </div>
        );
    }

    if (wifi.kind === "disconnected") {
        return (
            <div
                className={`inline-flex shrink-0 items-center ${className}`}
                title="Wi-Fi not connected"
            >
                <NoWifiIcon className={noWifiIconClass} />
            </div>
        );
    }

    const strength = wifi.signal != null ? wifi.signal : 50;

    return (
        <div className={`inline-flex shrink-0 items-center ${className}`} title="Wi-Fi connected">
            <NetworkIcon status={strength} className="shrink-0" />
        </div>
    );
};

export default WifiStatusBarIcon;
